import { optionsToStrategy } from "@/common/utils/optionsToStrategy"

export const options = [
  { label: 'Global', value: 'matrix' },
  { label: 'Por filial', value: 'branch' },
  { label: 'Definido pelo usuário', value: 'dynamic_branch' },
]

export const strategy = optionsToStrategy(options)
